export const pt = {
  heading: "Tecnologias",
  otherHeading: "Outras experiências",
  groups: [
    {
      icon: "code" as const,
      label: "Core",
      tone: "focus" as const,
      tags: [
        { label: "TypeScript", variant: "accent" as const },
        { label: "Node.js", variant: "accent" as const },
        { label: "Nest.js", variant: "outline" as const },
        { label: "Fastify", variant: "outline" as const },
        { label: "Express", variant: "outline" as const },
        { label: "Adonis.js", variant: "outline" as const },
        { label: "Prisma", variant: "outline" as const },
        { label: "TypeORM", variant: "outline" as const },
      ],
    },
    {
      icon: "sparkle" as const,
      label: "IA",
      tone: "focus" as const,
      tags: [
        { label: "OpenAI", variant: "outline" as const },
        { label: "Vercel AI SDK", variant: "outline" as const },
        { label: "OpenRouter", variant: "outline" as const },
        { label: "RAG", variant: "outline" as const },
        { label: "Agent workflows", variant: "outline" as const },
      ],
    },
    {
      icon: "plugsConnected" as const,
      label: "Mensageria",
      tone: "focus" as const,
      tags: [
        { label: "WebSocket", variant: "outline" as const },
        { label: "RabbitMQ", variant: "outline" as const },
        { label: "QStash", variant: "outline" as const },
      ],
    },
    {
      icon: "database" as const,
      label: "Dados",
      tone: "focus" as const,
      tags: [
        { label: "PostgreSQL", variant: "outline" as const },
        { label: "MySQL", variant: "outline" as const },
        { label: "MongoDB", variant: "outline" as const },
        { label: "Redis", variant: "outline" as const },
        { label: "SQLite", variant: "outline" as const },
        { label: "Meilisearch", variant: "outline" as const },
      ],
    },
    {
      icon: "sparkle" as const,
      label: "Engenharia assistida por IA",
      tone: "focus" as const,
      tags: [
        { label: "Cursor", variant: "outline" as const },
        { label: "Claude Code", variant: "outline" as const },
        { label: "Codex", variant: "outline" as const },
        { label: "OpenCode", variant: "outline" as const },
        { label: "T3 Code", variant: "outline" as const },
        { label: "Conductor", variant: "outline" as const },
        { label: "MCPs", variant: "outline" as const },
        { label: "Skills", variant: "outline" as const },
      ],
    },
  ],
  otherGroups: [
    {
      icon: "cloud" as const,
      label: "DevOps",
      tone: "other" as const,
      tags: [
        { label: "Docker", variant: "muted" as const },
        { label: "Google Cloud", variant: "muted" as const },
        { label: "Digital Ocean", variant: "muted" as const },
        { label: "Amazon S3", variant: "muted" as const },
        { label: "NGINX", variant: "muted" as const },
      ],
    },
    {
      icon: "code" as const,
      label: "Frontend",
      tone: "other" as const,
      tags: [
        { label: "JavaScript", variant: "muted" as const },
        { label: "TypeScript", variant: "muted" as const },
        { label: "React.js", variant: "muted" as const },
        { label: "HTML", variant: "muted" as const },
        { label: "CSS", variant: "muted" as const },
      ],
    },
    {
      icon: "plugsConnected" as const,
      label: "Blockchain",
      tone: "other" as const,
      tags: [
        { label: "Solidity", variant: "muted" as const },
        { label: "Tokens", variant: "muted" as const },
        { label: "NFTs", variant: "muted" as const },
        { label: "DEX", variant: "muted" as const },
        { label: "Web3.js", variant: "muted" as const },
        { label: "Ethers.js", variant: "muted" as const },
        { label: "Hardhat", variant: "muted" as const },
        { label: "Truffle", variant: "muted" as const },
      ],
    },
  ],
};
